import React from 'react';

import './button.scss';

interface IButtonProps {
  className?: string;
  children?: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  isDisabled?: boolean;
  pending?: boolean;
  size?: 'small' | 'medium' | 'big';
  type?: 'button' | 'submit' | 'reset';
}

const Button: React.FC<IButtonProps> = ({
  className = '',
  children,
  onClick,
  disabled = false,
  isDisabled = false,
  pending = false,
  size = 'medium',
  type = 'button',
}) => {
  const isButtonDisabled = disabled || isDisabled || pending;
  const buttonClass = `button ${className} size-${size} ${isButtonDisabled ? 'disabled' : ''} ${pending ? 'pending' : ''}`;

  return (
    <button
      type={type}
      className={buttonClass}
      onClick={onClick}
      disabled={isButtonDisabled}
    >
      {pending ? 'Loading...' : children}
    </button>
  );
};

export default Button;
